<div class="dialog-content">
  <div class="dismiss-button-placeholder">
    <button class="dismiss-button" (click)="dialogRef.close()" mat-icon-button>
      <i class="material-icons icon">close</i>
    </button>
  </div>
  <div class="options-placeholder">
    @for (option of data.options; track option) {
      <div class="option">
        <button
          [ngClass]="{ 'options-button': true, 'option-selected': option.value == data.selected?.value }"
          (click)="dialogRef.close(option)"
        >
          {{ option.label | translate }}
        </button>
      </div>
    }
  </div>
</div>
